// extracted by mini-css-extract-plugin
export default {"addressComponents":"AddressInput_addressComponents__6Fz5f","coordinatesWrapper":"AddressInput_coordinatesWrapper__pKV5c"};